import React, { useState } from "react";
import { Tooltip, ClickAwayListener } from "@mui/material";

const themeColorMap = {
  light: {
    backgroundColor: "#FFF",
    color: "#262626",
    boxShadow: (theme) => theme.shadows[3],
  },
  dark: {
    backgroundColor: "#262626",
    color: "#FFF",
  },
};

const ControlledCustomTooltip = ({
  theme = "light",
  showOnClick = false,
  children,
  title,
  maxWidth = "none",

  open: controlledOpen,
  onClose,
  openHandler = () => {},

  ...restProps
}) => {

  const [internalOpen, setInternalOpen] = useState(false);


  const isControlled = controlledOpen !== undefined;
  const open = isControlled ? controlledOpen : internalOpen;


  const handleTooltipClose = () => {
    if (isControlled) {
      onClose && onClose();
    } else {
      setInternalOpen(false);
    }
  };

 
  const handleTooltipOpen = (e) => {
    e.stopPropagation();

    openHandler && openHandler();

    if (!isControlled) {
      setInternalOpen(true);
    }
  };

  return (
    <Tooltip
      {...(showOnClick
        ? {
            open: open,
            onClose: handleTooltipClose,
            disableFocusListener: true,
            disableHoverListener: true,
            disableTouchListener: true,
          }
        : {})}
      componentsProps={{
        tooltip: {
          sx: {
            ...themeColorMap[theme],
            maxWidth: maxWidth,
            fontSize: "12px",
          },
        },
      }}
      title={
        title ? (
          <ClickAwayListener onClickAway={handleTooltipClose}>
            <div>
              {typeof title === "function"
                ? title(handleTooltipClose)
                : title}
            </div>
          </ClickAwayListener>
        ) : (
          ""
        )
      }
      {...restProps}
    >
      {React.cloneElement(children, {
        onClick: handleTooltipOpen,
      })}
    </Tooltip>
  );
};

export default ControlledCustomTooltip;